import React, { useEffect } from 'react';
import { Nav } from './nav.tsx';
import { Footer } from './footer.tsx';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import i18next from 'i18next';

type ParlaFunctions = {
  load: () => void;
  [key: `popup${number}`]: () => void;
}

type ParlaDoc = Document & {
  parla: ParlaFunctions;
}

export function Payment() {
    const { lang } = useParams();
    const { t } = useTranslation();
    const baseURL = "https://www.parlaretail.com";
    useEffect(() => {
        if (lang) {
            i18next.changeLanguage(lang);
        }
    }, [lang]);

    return (
        <>
            <Helmet key={lang}>
                {/* General Meta */}
                <meta charSet="utf-8" />
                <meta http-equiv="X-UA-Compatible" content="IE=edge" />
                <title>{t('payment.meta.title')}</title>
                <meta name="description" content={t('payment.meta.description')} />
                <meta name="keywords" content={t('payment.meta.keywords')} />
                <meta name="viewport" content="width=device-width, initial-scale=1" />

                {/* Open Graph */}
                <meta property="og:type" content="website" />
                <meta property="og:title" content={t('payment.meta.title')} />
                <meta property="og:description" content={t('payment.meta.description')} />
                <meta property="og:url" content={`${baseURL}/${lang}/`} />
                <meta property="og:image" content={`${baseURL}/img/sharing-image.jpg`} />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={t('payment.meta.title')} />
                <meta name="twitter:description" content={t('payment.meta.description')} />
                <meta name="twitter:image" content={`${baseURL}/img/sharing-image.jpg`} />

                {/* Hreflang for Language Versioning */}
                <link rel="alternate" hrefLang="en" href={`${baseURL}/en/`} />
                <link rel="alternate" hrefLang="es" href={`${baseURL}/es/`} />

                {/* Favicon */}
                <link rel="icon" type="image/png" href={`${baseURL}/img/parla-fav.png`} />
            </Helmet>
            <Nav />
            <div className="page">
                {/* Hero Section */}
                <div className="section">
                    <div className="hero-how">
                        <div className="hero-text">
                            <div className="row">
                                <div className="w50">
                                    <div className="title f60 mf40 t-color-2 mb20">{t('payment.hero.title')}</div>
                                    <div className="btn-wrap">
                                        <button className="btn btn-dark" onClick={() => (document as ParlaDoc).parla.popup33()}>{t('payment.hero.button')}</button>
                                    </div>
                                </div>
                                <div className="w50 v-center">
                                    <img src="/img/platform/Payment page hero image Parla.png" alt={t('payment.hero.image_alt')} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Reduce Cart Abandonment Section */}
                <div className="section">
                    <div className="hero-how">
                        <div className="hero-text">
                            <div className="row">
                                <div className="w50">
                                    <div className="title f40 mf40 t-color-3 mb20">{t('payment.cart.title')}</div>
                                    <div className="title f60 mf40 t-color-2 mb20">{t('payment.cart.subtitle')}</div>
                                    <div className="sub-title t-color-3 f20 mb20">
                                        {t('payment.cart.description')}
                                        <ul className="ml50 mt20">
                                            {(t('payment.cart.features', { returnObjects: true }) as { bold: string; text: string }[]).map(
                                                (feature, index) => (
                                                    <li key={index}>
                                                        <span className="bold">{feature.bold}</span> {feature.text}
                                                    </li>
                                                )
                                            )}
                                        </ul>
                                    </div>
                                </div>
                                <div className="w50 v-center row p20 ml20">
                                    <img src="/img/platform/Payment link hero image Parla.png" alt={t('payment.cart.image_alt')} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Close Sales Section */}
                <div className="section">
                    <div className="section80 row">
                        <div className="hero-side-r f50 mf30 w50">
                            <div className="title t-center">{t('payment.final.title')}</div>
                            <div className="btn-wrap mt20 center-in p20">
                                <button className="btn btn-dark" onClick={() => (document as ParlaDoc).parla.popup33()}>{t('payment.final.button')}</button>
                            </div>
                        </div>
                        <div className="hero-side-l w50">
                            <img src="/img/platform/AdobeStock_553438415.jpg" alt={t('payment.final.image_alt')} />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}
